import {FaLock, FaPencilAlt, FaTrash} from "react-icons/fa";
import {getUrl} from "../../../constants/urls";

export const userListURL = getUrl("listUser");

export const LIST_HEADERS = [
  "username",
  "first_name",
  "last_name",
  "email",
  "is_staff",
  "is_superuser",
  "is_active",
  "date_joined",
  "last_login",
];

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencilAlt, perms: ["change_user"]},
  {label: "Change Password", icon: FaLock, perms: ["change_user"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_user"]},
];

export const PERMS_FOR_ACTIONS = ["change_user", "delete_user"];

const userColumns = {
  Username: "username",
  Email: "email",
  "First Name": "first_name",
  "Last Name": "last_name",
  "Is Active": "is_active",
  "Is Superuser": "is_superuser",
  "Is Staff": "is_staff",
};

export const getColumnValue = (label) => {
  return userColumns[`${label}`];
};
